import { render, staticRenderFns } from "./group-members-screen.vue?vue&type=template&id=6392b030&"
import script from "./group-members-screen.vue?vue&type=script&lang=js&"
export * from "./group-members-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports